import { Form, Formik } from "formik";
import { PMButton } from "../../utils/PMButton";
import { PMDialog } from "../../utils/PMDialog";
import { PMField } from "../../utils/PMField";
import { ResourceLoading } from "../../utils/ResourceLoading";
import { DocumentViewer } from "./documentViewer";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { dispatchWithToast } from "../../Utils";
import { updateDocumentAsync } from "../../../slices/document";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PMSwitch from "../../utils/PMSwitch";

export const EditDocumentDialog = (props) => {
  const { open, onClose, selected, onRefresh, error, errors, editPublic } =
    props;

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const [document, setDocument] = useState(props.document);

  useEffect(() => {
    setDocument(props.document);
  }, [props.document]);

  return (
    <PMDialog open={open} onClose={onClose} title="Edit document">
      <Formik
        initialValues={{
          id: document?.id,
          title: document?.title,
          filename: document?.file?.filename,
          public: document?.public,
          submit: null,
        }}
        validationSchema={Yup.object({
          id: Yup.number().required("ID is required. Document is not valid."),
        })}
        onSubmit={(values, helpers) => {
          try {
            dispatchWithToast(
              dispatch(updateDocumentAsync(values)),
              (data) => {
                if (onRefresh) {
                  onRefresh(data);
                }
                setDocument(data);
                setLoading(false);
                onClose();
              },
              () => setLoading(false)
            );

            helpers.setStatus({ success: true });
            helpers.setSubmitting(false);
          } catch (err) {
            setLoading(false);
            toast.error("Something went wrong...");
            console.error(err);
            helpers.setStatus({ success: false });
            helpers.setErrors({ submit: err.message });
            helpers.setSubmitting(false);
          }
        }}
      >
        {(formik) => {
          if (loading) {
            return <ResourceLoading />;
          }


          return (
            <Form className="mb-20">
              {/* Error if ID is missing here */}
              {formik.errors["id"] && (
                <div className="bg-red-100 text-red-800 border border-red-400 p-2 mb-2">
                  {formik.errors["id"]}
                </div>
              )}

              <div className="py-2">
                <PMField label="Title" name="title" {...formik} />
              </div>
              <div className="py-2">
                <PMField
                  disabled
                  label="Filename"
                  name="filename"
                  {...formik}
                />
              </div>

              {editPublic && (
                <div className="py-2">
                  <PMSwitch label="public" name="public" {...formik} />
                </div>
              )}

              <PMButton
                type="submit"
                styleType="primary"
                className="bg-green-400 hover:bg-green-200"
              >
                Save
              </PMButton>
            </Form>
          );
        }}
      </Formik>
    </PMDialog>
  );
};

EditDocumentDialog.defaultProps = {
  editPublic: false,
};
